import { AuthAppSession } from "src/features/hq/auth-monitor/models";

export enum ConnectionName {
  youtube = 'YouTube',
  instagram = 'Instagram',
  facebook = 'Facebook',
  spotify = 'Spotify',
  distrokid = 'Distrokid',
  arelia = 'Arelia Authenticator',
  songtrust = 'Songtrust',
  amazon = 'Amazon',
  shopify = 'Shopify',
  square = 'Square',
  tiktok = 'TikTok',
  appleMusic = "Apple Music",
  pandora = "Pandora",
  cdBaby = "CDBaby",
  twitter = "Twitter",
  ascap = "ASCAP"
};

export function mapConnectionUIName(name: ConnectionName): string {
  if (name === ConnectionName.distrokid) return "DistroKid";
  if (name === ConnectionName.twitter) return "X (Twitter)";
  return name;
}

export enum ConnectionStatus {
  connected = 'Connected',
  notConnected = 'Not connected',
  notSupported = 'Not supported',
  notAuthorized = 'Not Authorized'
};

export type Connection = {
  connected: boolean;
  unauthorized: boolean;
  identityId: string;
  login: string | null;
  accounts: { id: string; name: string; isPostingEnabled: boolean }[];
  name: ConnectionName;
  newerVersion: string;
  updatedAt: Date;
  maintenanceState: string | null;
  sessions: AuthAppSession[];
}

export type ConnectionDto = Connection & {
  status: ConnectionStatus;
  icon: string;
  type: ConnectionType[] | null;
}

export type ConnectionForm = {
  accounts: { id: string; name: string }[];
};

export type MetaPage = {
  id: string;
  name: string;
};

export enum ConnectionType {
  social = 'social',
  streaming = 'streaming',
  earnings = 'earnings'
}
